import {useEffect, useRef} from 'react'
import './web-phone.scss'
import {useDispatch, useSelector} from 'react-redux'
import {setOpenEmbeddedPhone} from '../../state/settingsSlice'


export const WebPhone = () => {
    const openEmbeddedPhone = useSelector(state => state.settings.openEmbeddedPhone)
    const alvariaEmbeddedUrl = useSelector(state => state.embedded.alvariaEmbeddedUrl)
    const dispatch = useDispatch()

    const ref = useRef(null)
    useEffect(() => {
        if (!alvariaEmbeddedUrl) {
            return
        }
        const el = document.getElementById('alvaria-iframe')
        if (!el) {
            const iframe = document.createElement('iframe')
            iframe.setAttribute('id', 'alvaria-iframe')
            iframe.setAttribute('src', alvariaEmbeddedUrl)
            iframe.setAttribute('allow', 'microphone; sound')
            ref.current.appendChild(iframe)
        }
    }, [alvariaEmbeddedUrl])


    let display = 'block'
    if (!openEmbeddedPhone) {
        display = 'none'
    }

    const onClick = () => {
        dispatch(setOpenEmbeddedPhone(false))
    }

    return <div style={{display}} className="alvaria-embedded-container">
        <span onClick={onClick}>
            <span>x</span>
        </span>
        <div ref={ref}>

        </div>
    </div>
}